module.exports = __webpack_public_path__ + "static/img/jianzhu12.d501328.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Content/Friend/jianzhu12.png
// module id = uDcT
// module chunks = 12